{
  "name": "online-membership-sales-office-frontend",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:docker": "ng build -c=docker --output-hashing=bundles"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.22",
    "@angular/common": "21.2.22",
    "@angular/compiler": "21.2.22",
    "@angular/core": "21.2.22",
    "@angular/forms": "21.2.22",
    "@angular/platform-browser": "21.2.22",
    "@angular/platform-browser-dynamic": "21.2.22",
    "@angular/router": "21.2.22",
    "@angular/service-worker": "21.2.22",
    "@azure/msal-angular": "6.2.0",
    "@azure/msal-browser": "5.21.0",
    "@bayclubs/drop-down": "13.2.0",
    "@bayclubs/employee-auth": "20.0.2",
    "@bayclubs/employee-management-api": "2.24.0",
    "@bayclubs/horizon": "0.9.3",
    "@bayclubs/logging": "10.0.0",
    "@bayclubs/spinner": "13.0.0",
    "@bayclubs/ui-core": "4.0.0",
    "@bayclubs/ui-date-picker": "8.0.0",
    "@bayclubs/ui-drop-down": "6.1.0",
    "@bayclubs/ui-icons": "4.1.0",
    "@bayclubs/ui-styles": "4.0.0",
    "@bayclubs/utils": "13.0.0",
    "@grafana/faro-web-sdk": "2.11.0",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@ngxs/devtools-plugin": "21.0.0",
    "@ngxs/router-plugin": "21.0.0",
    "@ngxs/storage-plugin": "21.0.0",
    "@ngxs/store": "21.0.0",
    "bootstrap": "4.6.2",
    "chart.js": "^4.5.1",
    "guid-typescript": "1.0.9",
    "jquery": "3.7.1",
    "lodash": "^4.17.21",
    "lodash-es": "^4.17.21",
    "moment": "2.30.1",
    "moment-timezone": "0.6.3",
    "ngx-bootstrap": "21.2.2",
    "ngx-clipboard": "16.0.0",
    "ngx-device-detector": "11.0.0",
    "ngx-infinite-scroll": "21.0.0",
    "ngx-mask": "21.1.0",
    "popper.js": "1.16.1",
    "rxjs": "7.8.2",
    "text-mask-addons": "3.8.0",
    "tslib": "2.8.1",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.23",
    "@angular/cli": "21.2.23",
    "@angular/compiler-cli": "21.2.22",
    "@angular/language-service": "21.2.22",
    "typescript": "5.9.3"
  }
}
